import * as Api from '@ViewModels';

// Define types for tag search
export enum TagSearchRequestProperty {
	Name = 'Name',
	Favorite = 'Favorite',
}

export interface ITagsSearchFilter {
	criteria: {
		property: TagSearchRequestProperty;
		value?: string;
	}[];
}

export const getTagSearchFromCriteria = (criteria: ITagsSearchFilter['criteria']) => {
	const selected = criteria.find(x => x.property === TagSearchRequestProperty.Name);
	return selected?.value || '';
};

export const DefaultTagsFilter: ITagsSearchFilter = {
	criteria: [{ property: TagSearchRequestProperty.Name, value: '' }],
};

export const DefaultTagsSort: Api.ISortDescriptor = {
	sort: 'asc',
	sortBy: 'name',
};
